// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__asn_P","bed":"Card_bed__hWgzx"};